import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { UseCase } from "../../base/use-case";
import { Job } from "../../domain/models/job";
import { JobsRepository } from "../../repositories";

@Injectable({ providedIn: 'root' })
export class GetPlanJobsUsecase implements UseCase<string, Job[]> {

  constructor(private jobRepository: JobsRepository) {
  }

  execute(params: string): Observable<Job[]> {
    return this.jobRepository.getPlanJobs(params);
  }

}
